import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import CustomerCreditAccountFooterStyle from './css/CustomerCreditAccountFooterStyle'
import CustomerAccountItemController from '../customer_account_item/CustomerAccountItemController'
import { customerCreditAccountControllerContext } from '../customer_credit_account/CustomerCreditAccountController'
import { appContext } from '../../../App'
import { saveCustomer } from '../CustomersAccountsFunctions'

function CustomerCreditAccountFooter() {
  const app = useContext(appContext)
  const customerCreditAccountController = useContext(customerCreditAccountControllerContext)
  const setContent = app.content[1]
  const { customerAccount, creditAccount, setPayClicked } = customerCreditAccountController
  const tabContent = customerCreditAccountController.tabContent

  const onClickPrint = (e) => window.print()

  const onClickPay = (e) => setPayClicked(true)

  const onClickBackToCustomerAccountDetail = async (e) => {
    const credit_account = customerAccount.credit_accounts.find((ca) => (ca.credit_account_number === parseInt(creditAccount.credit_account_number)))
    credit_account.status = null

    // Update customer account due to changes on credit_account status that we've made
    await saveCustomer(app, customerAccount)

    setContent(<CustomerAccountItemController id={customerAccount._id} />)
  }

  return (
    <ContentFooter>
      <div className='action-buttons-container'>
        <button
          onClick={onClickBackToCustomerAccountDetail}
          className='pospro-action-btn'>
          <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Customer Account Detail
        </button>

        {
          (tabContent) ?
            <button
              className='pospro-action-btn'
              onClick={onClickPrint}>
              <FontAwesomeIcon icon='print'/>&nbsp;Print
            </button>
          : null
        }

        {
          (creditAccount) ?
            (creditAccount.status === 'On Process') ?
              <button
                onClick={onClickPay}
                disabled={(creditAccount.total_balance === 0)}
                className={(creditAccount.total_balance === 0) ? 'pospro-action-btn disabled-button' : 'pospro-action-btn'}>
                <FontAwesomeIcon icon='coins'/>&nbsp;Pay
              </button>
            : null
          : null
        }
      </div>
      <CustomerCreditAccountFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(CustomerCreditAccountFooter)
